export const CACHE_KEY_CONTACT_MESSAGE = 'TP-CONTACT-MESSAGE';
export const CACHE_KEY_QUIZ_ANSWERS = 'TP-QUIZ-ANSWERS';
export const CACHE_KEY_QUIZ_EMAIL = 'TP-QUIZ-EMAIL';
export const CACHE_KEY_COMPARATOR_EMAIL = 'TP-COMPARATOR-EMAIL';
export const CACHE_KEY_NEWSLETTER_MODAL_PERSIST_DATE = 'TP-NEWSLETTER-MODAL-PERSIST-DATE';
export const CACHE_KEY_UNFINISHED_APPLICATION_ID = 'UNFINISHED_APPLICATION_ID';
export const CACHE_KEY_UNFINISHED_APPLICATION_DATA = 'UNFINISHED_APPLICATION_DATA';
export const CACHE_KEY_PURCHASE_EVENT_SENT = 'TP-PURCHASE-EVENT-SENT';
export const CACHE_KEY_UPDATE_LITTER_MODAL_PERSIST_DATE = 'TP-UPDATE_LITTER_MODAL_PERSIST_DATE';
export const CACHE_KEY_BREEDER_STORE_PARTNERSHIP_MODAL_PERSIST_DATE =
  'TP-BREEDER_STORE_PARTNERSHIP_MODAL_PERSIST_DATE';
